<template>
<div class="modal fade" id="previoussummary" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="max-width:780px;position:fixed;max-height:85vh;overflow-y:auto;margin-left:-390px;left:50%;" id="MlListpopupContent">
       <div class="modal-content">
          <div  class="modal-header">
             <h5  class="modal-title text-center pull-left w-100 d-block mt-4 pb-0 mb-2 mb-0">Previous Summary </h5>
            
             <button  type="button" data-dismiss="modal" class="close d-close"><i  class="material-icons">close</i></button>
          </div>
   
           <div  class="modal-body mt-0 pt-0">             
<div class="col-12"><p class="text-info">Notes: Click the content copy to Doctor summary</p></div>
            <!---->
            <div  class="col-12">
                    <!-- <textarea class="form-control" style="min-height:225px;"></textarea> -->
                    <p :style="{ color: 'grey' }" :id="'previous_summary_line_'+prev_summary_arr_index+'_'+line_index" v-on:click="UseLine('previous_summary_line_' +prev_summary_arr_index+'_'+line_index)" v-for="(item,line_index) in selected_previous_summary" :key="prev_summary_arr_index+'_'+line_index">{{item}}</p>
            </div>
           
         </div>
       </div>
    </div>    
      
 </div>
   
       
                
          
    
  
</template>

<script>
 
 
import Axios from "axios";
import rest_service from "@/api/rest_service";
export default {
   props:['selected_previous_summary','prev_summary_arr_index'],
   methods:{
      UseLine(id){
         if( !$("#"+id).hasClass("line-selected")){
            $("#" + id).css("color", "black");
            $("#" + id).addClass("line-selected");
            this.$emit("SelectedLine", $('#'+id).text());
            }
      },
   }
};
</script>

 

<style > 

</style>